const SPOKE_COLORS = [
  '#000000',
  '#d9d9d9',
  '#c4c4c4',
  '#aeaeae',
  '#989898',
  '#828282',
  '#6d6d6d',
  '#414141',
]

export function LoadingSpinner({ className = '' }: { className?: string }) {
  return (
    <span
      className={`relative inline-block size-8 animate-spinner ${className}`}
      role="status"
      aria-label="불러오는 중"
    >
      {SPOKE_COLORS.map((color, i) => (
        <span
          key={color}
          className="absolute top-1/2 left-1/2 h-[8px] w-[2.667px] rounded-[6.667px]"
          style={{
            backgroundColor: color,
            // 중심에 겹쳐 두고 각도만큼 돌린 뒤 반지름 12 만큼 밀어낸다.
            transform: `translate(-50%, -50%) rotate(${i * 45}deg) translateY(-12px)`,
          }}
        />
      ))}
    </span>
  )
}
